import React, { useState, useEffect } from "react";
import Card from "./card";
import Card1 from "./card1";
import Card2 from "./card2";
import "./index.css"
import { useNavigate } from "react-router-dom";
const Body = () => {
    const [activeIndex, setActiveIndex] = useState(0);
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    const navigate = useNavigate();

    const headlines = [" Home", "Even When You’re Away"];

    useEffect(() => {
        const interval = setInterval(() => {
            setActiveIndex((prevIndex) => (prevIndex + 1) % headlines.length);
        }, 2000); // Change headline every 1 second

        return () => clearInterval(interval); // Cleanup on unmount
    }, [headlines.length]);

    useEffect(() => {
        const handleResize = () => {
            setScreenWidth(window.innerWidth);
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const isMobileView = screenWidth < 998;

    return (
        <div className="body2">
            {/* Top Section with Animation */}
            <section
                style={{
                    backgroundColor: "#EE4358",
                    color: "white",
                    textAlign: "center",
                    padding: "140px 20px",
                    position: "relative",
                }}
            >
                <h1 style={{ fontSize: "6.5rem" }} className="responsive-heading">
                    Feels like
                </h1>
                <div
                    style={{
                        position: "relative",
                        height: "124px", // Ensure enough space for the animation
                        overflow: "hidden",
                        marginBottom: "32px"
                    }}
                    className="responsive-height-animation"
                >
                    {headlines.map((text, index) => (
                        <h1
                            key={index}
                            style={{
                                fontSize: "6.5rem",
                                position: "absolute",
                                top: 0,
                                left: 0,
                                right: 0,
                                opacity: activeIndex === index ? 1 : 0,
                                transform:
                                    activeIndex === index
                                        ? "translateY(0)"
                                        : "translateY(100%)",
                                transition: "opacity 0.5s, transform 0.5s",
                            }}
                            className="responsive-heading"
                        >
                            {text}
                        </h1>
                    ))}
                </div>
                <div style={{ display: "flex", justifyContent: "center", gap: "20px" }}>
                    <button
                        style={{
                            padding: "10px 20px",
                            backgroundColor: "white",
                            // color: "#EE4358",
                            color: "black",
                            border: "none",
                            borderRadius: "5px",
                            fontSize: "1rem",
                            cursor: "pointer",
                        }}
                        className="btn-white-background"
                        onClick={() => navigate("./contactUs")}
                    >
                        Get in touch
                    </button>
                    <button
                        style={{
                            padding: "10px 20px",
                            backgroundColor: "transparent",
                            color: "white",
                            border: "1px solid white",
                            borderRadius: "5px",
                            fontSize: "1rem",
                            cursor: "pointer",
                        }}
                        onClick={() => navigate("./ourServices")}
                        className="btn-red-background"
                    >
                        Explore our services
                    </button>
                </div>
                {/* Add animation logic here */}
            </section>
            <section>
                <div className="image-container">
                    <img src="./polygun.png" alt="polygun" style={{ position: "relative", }} />
                </div>
            </section>

            {/* Metrics Section */}
            <section
                style={{ padding: "120px 20px", marginLeft: "200px", marginRight: "200px" }}
                className="matrix-wrappper"
            >
                <h2
                    style={{ textAlign: "center", marginBottom: "40px" }}
                    className="matrix-text"
                >
                    Providing Safe, Comfortable, and Well-Managed PG Accommodations
                </h2>
                <div
                    className="mobile-matrices"
                    style={{
                        display: "flex",
                        justifyContent: "space-around",
                        flexWrap: "wrap",
                        textAlign: "center",
                    }}
                >
                    {[
                        { metric: "95%", label: "Resident Satisfaction" },
                        { metric: "10+", label: "Years of Experience" },
                        { metric: "90%", label: "Occupancy Rate" },
                        { metric: "5+", label: "Facilities & Amenities Provided" },
                    ].map((item, index) => (
                        <div key={index} style={{ margin: "10px" }}>
                            <h3 style={{ fontSize: "4rem", marginBottom: "10px" }} className="matrix-num">{item.metric}</h3>
                            <p style={{ fontWeight: "600" }}>{item.label}</p>
                        </div>
                    ))}
                </div>
            </section>


            <section>
                <div className="image-container">
                    <img src="./polygon2.png" alt="polygun" style={{ position: "relative", }} />
                </div>
            </section>

            {/* Services Section */}
            <section style={{ backgroundColor: "#EE4358", color: "white", padding: "60px 20px" }}>
                <h2 style={{ textAlign: "center", marginBottom: "40px" }} className="text-mobile-services">
                    Why Choose Our PG Accommodations?
                </h2>
                <p style={{ textAlign: "center", marginBottom: "40px" }}>
                    4 Core Amenities for a Comfortable Stay
                </p>
                {
                    !isMobileView ?
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                flexWrap: "wrap",
                                gap: "20px",
                            }}
                        >
                            {[
                                {
                                    title: "Safe & Secure",
                                    description: "24/7 CCTV surveillance, security personnel, and controlled access for peace of mind.",
                                    hoverDescription: "Our PG ensures complete safety with CCTV cameras, trained security guards, and strict entry policies. Residents can feel secure whether they are in their rooms or common areas.",

                                },
                                {
                                    title: "Hygienic & Comfortable Rooms",
                                    description: "Regular cleaning, well-maintained rooms, and comfortable furnishings for a cozy stay.",
                                    hoverDescription: "We prioritize cleanliness and comfort. Rooms are cleaned daily, linen is changed regularly, and common areas are maintained to ensure a pleasant living environment.",

                                },
                                {
                                    title: "Delicious & Healthy Meals",
                                    description: "Top-notch tiffin service with hygienic, home-style meals to suit your dietary needs.",
                                    hoverDescription: "Residents enjoy freshly prepared meals every day, keeping hygiene and nutrition in mind. Custom diet preferences can also be accommodated.",

                                },
                                {
                                    title: "Convenient Amenities",
                                    description: "Power backup, lifts, Wi-Fi, laundry, and recreational spaces for all residents.",
                                    hoverDescription: "We provide modern amenities like uninterrupted power backup, high-speed Wi-Fi, lifts, laundry services, and recreational areas, making your stay convenient and enjoyable.",

                                }
                            ].map((service, index) => (
                                <div
                                    key={index}
                                    style={{
                                        color: "#262626",
                                        borderRadius: "10px",
                                        padding: "20px",
                                        maxWidth: "270px",
                                        textAlign: "left",
                                    }}
                                    className="service-tile"
                                >
                                    <div className="normal-content">

                                        <h3 style={{ marginBottom: "10px", marginTop: "10px", fontSize: "1rem", fontWeight: "bold" }}>
                                            {service.title}
                                        </h3>
                                        <p style={{ textAlign: "left" }}>{service.description}</p>
                                    </div>
                                    <div className="hover-content">
                                        <h3 style={{ color: "white", marginBottom: "10px", marginTop: "10px", fontSize: "1rem", fontWeight: "bold" }}>
                                            {service.title}
                                        </h3>
                                        <p style={{ fontSize: "12px", color: "white", textAlign: "left" }}>{service.hoverDescription}</p>
                                    </div>
                                </div>
                            ))}

                        </div>
                        :
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                flexWrap: "wrap",
                                gap: "20px",
                            }}
                        >
                            {[
                                {
                                    title: "Safe & Secure",
                                    hoverDescription: "24/7 CCTV surveillance, trained security guards, and controlled access ensure peace of mind for all residents.",
                                    src: "./security.png"
                                },
                                {
                                    title: "Hygienic & Comfortable Rooms",
                                    hoverDescription: "Daily cleaning, well-maintained rooms, and cozy furnishings make your stay comfortable and pleasant.",
                                    src: "./room.png"
                                },
                                {
                                    title: "Delicious & Healthy Meals",
                                    hoverDescription: "Freshly prepared home-style meals, tailored to your dietary preferences, served daily for your convenience.",
                                    src: "./meal.png"
                                },
                                {
                                    title: "Convenient Amenities",
                                    hoverDescription: "Power backup, lifts, Wi-Fi, laundry services, and recreational spaces to make your life easy and enjoyable.",
                                    src: "./amenities.png"
                                }
                            ].map((service, index) => (
                                <div
                                    key={index}
                                    style={{
                                        color: "#262626",
                                        borderRadius: "30px",
                                        padding: "20px",
                                        textAlign: "left",
                                    }}
                                    className="service-tile"
                                >
                                    <div className="">
                                        <img src={service.src} alt={service.title} />
                                        <h3 style={{ marginBottom: "10px", marginTop: "10px", fontSize: "1rem", fontWeight: "bold" }}>
                                            {service.title}
                                        </h3>
                                        <p style={{ textAlign: "left" }}>{service.hoverDescription}</p>
                                    </div>
                                </div>
                            ))}

                        </div>
                }
            </section>


            <section>
                <div className="image-container">
                    <img src="./polygun.png" alt="polygun" style={{ position: "relative", }} />
                </div>
            </section>

            {/* Testimonials Section */}
            {/* <section style={{ backgroundColor: "#fff8f5", padding: "60px 20px" }}>
                <h2 style={{ textAlign: "center", marginBottom: "40px" }}>Clients who trust us</h2>
                <div style={{ textAlign: "center", marginBottom: "40px" }}>
                    <p style={{ fontSize: "1.2rem", marginBottom: "20px" }}>
                        "Their comfortable and secure accommodation has been perfect for our students. Agarwal's Paying Guest understands our needs and delivers exceptional service with great value."
                    </p>
                    <p style={{ fontWeight: "bold" }}>Adam Markowitz</p>
                    <p>Student Parent</p>
                </div>
                <div style={{ textAlign: "center" }}>
                    <button style={{ margin: "0 10px", cursor: "pointer" }}>&lt;</button>
                    <button style={{ margin: "0 10px", cursor: "pointer" }}>&gt;</button>
                </div>
            </section> */}

            {/* Contact Section */}
            {/* <section style={{ backgroundColor: "#d9534f", color: "white", padding: "60px 20px" }}>
                <h2 style={{ textAlign: "center", marginBottom: "20px" }}>Get in touch</h2>
                <p style={{ textAlign: "center" }}>
                    Your Dedicated Go To Market Team
                </p>
                <div style={{ textAlign: "center" }}>
                    <button
                        style={{
                            padding: "10px 20px",
                            backgroundColor: "white",
                            color: "#d9534f",
                            border: "none",
                            borderRadius: "5px",
                            fontSize: "1rem",
                            cursor: "pointer",
                        }}
                    >
                        Hire us now
                    </button>
                </div>
            </section> */}

            <section style={{ paddingTop: "120px", background: "#FFF5EE", display: "flex", justifyContent: "center", alignContent: "center", flexDirection: "column", alignItems: "center" }}>
                <div className="text-client">Client Who trust Us</div>
                <Card />
                <div style={{ marginTop: "120px" }}>
                    <Card2 />
                </div>
            </section>
            <section style={{ marginTop: "120px" }}>
                <div className="image-container">
                    <img src="./polygon2.png" alt="polygun" style={{ position: "relative", }} />
                </div>
            </section>
        </div>
    );
};

export default Body;
